const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"f893bbcdcbaa0e5ed8f82276ed2b1c345b29c316"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["web-frontend@codingal-inc"]={id:"f893bbcdcbaa0e5ed8f82276ed2b1c345b29c316"};
      